import { getBooleanStringValue } from '@juvare/credentialing/backend/utils';
export function getShiftPositionAccountFilter({ deploymentDurations, position, }) {
    const shiftPositionAccountFilter = [];
    if (position.data.occupationIds && position.data.occupationIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'occupationIds',
            op: 'overlap',
            value: position.data.occupationIds,
        });
    }
    if (position.data.ecl && position.data.ecl.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'ecls',
            op: 'overlap',
            value: position.data.ecl,
        });
    }
    if (position.data.skillIds && position.data.skillIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'skillIds',
            op: 'contains',
            value: position.data.skillIds,
        });
    }
    if (position.data.trainingIds && position.data.trainingIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'trainingCourseIds',
            op: 'contains',
            value: position.data.trainingIds,
        });
    }
    if (position.data.languageIds && position.data.languageIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'languageIds',
            op: 'contains',
            value: position.data.languageIds,
        });
    }
    if (position.data.state) {
        shiftPositionAccountFilter.push({
            column: 'state',
            op: '=',
            value: position.data.state,
        });
    }
    if (position.data.residenceType === 'county' && position.data.counties && position.data.counties.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'county',
            op: 'in',
            value: position.data.counties,
        });
    }
    if (position.data.residenceType === 'tribe' && position.data.tribeIds && position.data.tribeIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'tribeId',
            op: 'in',
            value: position.data.tribeIds,
        });
    }
    if (position.data.deploymentDurationId && deploymentDurations[position.data.deploymentDurationId] != null) {
        shiftPositionAccountFilter.push({
            column: 'deploymentDuration',
            op: '>=',
            value: deploymentDurations[position.data.deploymentDurationId],
        });
    }
    if (position.data.deploymentTravelWillingnessIds && position.data.deploymentTravelWillingnessIds.length > 0) {
        shiftPositionAccountFilter.push({
            column: 'deploymentTravelIds',
            op: 'overlap',
            value: position.data.deploymentTravelWillingnessIds,
        });
    }
    if (position.data.federalDeploymentWillingness != null) {
        shiftPositionAccountFilter.push({
            column: 'workUnderFederalGovernment',
            op: '=',
            value: getBooleanStringValue(position.data.federalDeploymentWillingness),
        });
    }
    if (position.data.priorCommitments != null) {
        shiftPositionAccountFilter.push({
            column: 'priorCommitment',
            op: '=',
            value: getBooleanStringValue(position.data.priorCommitments),
        });
    }
    return shiftPositionAccountFilter;
}
